import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { customBlogListReducer, CustomBlogListState } from "@tggstore/Store/State/Blog/BlogListState";
import {
    customDefaultWarehouseReducer,
    DefaultWarehouseState,
} from "@tggstore/Store/State/Custom/DefaultWarehouseState";
import {
    customProductCategoriesReducer,
    ProductCategoriesState,
} from "@tggstore/Store/State/Custom/ProductCategoriesState";
import { customStatementReducer, StatementState } from "@tggstore/Store/State/Custom/StatementState";
import { customSystemListReducer, SystemListState } from "@tggstore/Store/State/Custom/SystemListState";
import { customTransactionTypeReducer, TransactionTypeState } from "@tggstore/Store/State/Custom/TransactionType";
import {
    customTransactionTypeOptionsReducer,
    TransactionTypeOptionsState,
} from "@tggstore/Store/State/Custom/TransactionTypeOptions";
import {
    customUpdatePartNumberReducer,
    UpdatePartNumberState,
} from "@tggstore/Store/State/Custom/UpdateMyPartNumberState";
import { customWarehouseListReducer, WarehouseListState } from "@tggstore/Store/State/Custom/WarehouseListState";

import customOnePageCheckoutReducer from "@tggstore/Store/State/Pages/OnePageCheckout/OnePageCheckoutReducer";
import  OnePageCheckoutState from "@tggstore/Store/State/Pages/OnePageCheckout/OnePageCheckoutState";

export type CustomState = {
    name: string;
    customWareHouseList: WarehouseListState;
    customDefaultWarehouse: DefaultWarehouseState;
    customProductCategories: ProductCategoriesState;
    customTransactionType: TransactionTypeState;
    customTransactionTypeOptions: TransactionTypeOptionsState;
    customStatement: StatementState;
    customUpdatePartNumberType: UpdatePartNumberState;
    customSystemList: SystemListState;
    blogList: CustomBlogListState;
    customOnePageCheckout: OnePageCheckoutState;
} & ApplicationState;

(reducers as any).customWareHouseList = customWarehouseListReducer;
(reducers as any).customDefaultWarehouse = customDefaultWarehouseReducer;
(reducers as any).customProductCategories = customProductCategoriesReducer;
(reducers as any).customTransactionType = customTransactionTypeReducer;
(reducers as any).customTransactionTypeOptions = customTransactionTypeOptionsReducer;
(reducers as any).customStatement = customStatementReducer;
(reducers as any).customUpdatePartNumberType = customUpdatePartNumberReducer;
(reducers as any).customSystemList = customSystemListReducer;
(reducers as any).blogList = customBlogListReducer;
(reducers as any).customOnePageCheckout = customOnePageCheckoutReducer;

type Reducers = {
    customBlogListReducer: typeof customBlogListReducer;
    customWareHouseList: typeof customWarehouseListReducer;
    customDefaultWarehouse: typeof customDefaultWarehouseReducer;
    customProductCategories: typeof customProductCategoriesReducer;
    customTransactionType: typeof customTransactionTypeReducer;
    customTransactionTypeOptions: typeof customTransactionTypeOptionsReducer;
    customStatement: typeof customStatementReducer;
    customUpdatePartNumberType: typeof customUpdatePartNumberReducer;
    customSystemList: typeof customSystemListReducer;
    customOnePageCheckout: typeof customOnePageCheckoutReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
